const ACTIVITY_KEY = "Collection";
const ACTIVITY_TYPE = "deposit_spend"; // deposit, spend, deposit_spend

export default {
  namespaced: true,
  state: {
    is_active: null,
    current_time: null,
    ends_at: null,
    starts_at: null,
    acquirable_until_time: null,
    prize_conditions: null,
    prizes: null,
    activity_type: ACTIVITY_TYPE,
    progress: null,
    popup: null, // exchange_row, exchange_superprize, reward_row, reward_superprize, new_card, new_card_all
    current_reward: null,
    current_row: null,
    new_card: null,
    new_card_all: null,
    deposit_step: null,
    deposit_min_cards_amount: null,
    deposit_max_cards_amount: null,
  },

  getters: {
    getActivityType() {
      // There is no such feature on backend yet.
      return ACTIVITY_TYPE;
    },

    isUserJoined(state) {
      return state.progress ? state.progress.is_joined : false;
    },

    getBalance(state) {
      return state.progress ? state.progress.total_deposit_amount : 0;
    },

    getDeckCount(state) {
      return state.progress ? state.progress.cards_amount : 0;
    },

    isDeckBlocked(state) {
      return state.progress.rows.some((row) => row.cards_amount === 5);
    },

    getMaxShardsCount(state) {
      return state.prize_conditions
        ? state.prize_conditions[state.prize_conditions.length - 1].cells_amount
        : 0;
    },

    getSuperprizeLimit(state) {
      return (
        state.prize_conditions && state.prize_conditions[state.prize_conditions.length - 1].limit
      );
    },
    getSuperprizeClaimedAmount(state) {
      return state.progress && state.progress.rows[state.progress.rows.length - 1].claimed_amount;
    },

    getPrizesList(state) {
      let prizes_list = {
        rows: [],
        superprize: "",
      };

      if (state.prizes) {
        prizes_list.superprize = state.prizes[state.prizes.length - 1];

        let prizes_rows = state.prizes.slice(0, state.prizes.length - 1);

        for (let i = 0; i < prizes_rows.length; i++) {
          prizes_list.rows.push(prizes_rows[i]);
        }
      }

      return prizes_list;
    },

    getCardsList(state) {
      let cards_list = {
        rows: [],
        superprize: 0,
      };

      state.progress.rows.forEach((row, index) => {
        if (index === state.progress.rows.length - 1) {
          cards_list.superprize = row.cards_amount;
        } else {
          cards_list.rows.push(row.cards_amount);
        }
      });

      return cards_list;
    },

    getAllOpenedCards(state) {
      return state.new_card_all;
    },
  },

  mutations: {
    initGameData(state, data) {
      state.is_active = data.is_active;
      state.current_time = data.current_time;
      state.ends_at = data.ends_at;
      state.starts_at = data.starts_at;
      state.acquirable_until_time = data.acquirable_until_time;
      state.prize_conditions = data.rows;
      state.deposit_step = data.deposit_step;
      state.deposit_min_cards_amount = data.deposit_min_cards_amount;
      state.deposit_max_cards_amount = data.deposit_max_cards_amount;
    },

    setPrizes(state, data) {
      state.prizes = data;
    },

    setProgress(state, data) {
      state.progress = data;
    },

    setJoinStatus(state, data) {
      state.progress.is_joined = data;
    },

    setNewCard(state, data) {
      state.new_card = data;
    },

    setNewCardAll(state, data) {
      state.new_card_all = data;
    },

    placeNewCard(state, data) {
      state.progress.rows[data.level - 1].cards_amount = data.amount;
    },

    placeNewCardAll(state, data) {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        state.progress.rows[element.level - 1].cards_amount++;
      }
    },

    setPopup(state, data) {
      state.popup = data;
    },

    setCurrentReward(state, data) {
      state.current_reward = data;
    },

    setCurrentRow(state, data) {
      state.current_row = data;
    },

    removeRow(state) {
      let new_cards_amount = state.progress.rows[state.current_row - 1].cards_amount - 5;
      state.progress.rows[state.current_row - 1].cards_amount = new_cards_amount;
    },

    placeRow(state) {
      state.progress.rows[state.current_row - 1].cards_amount = 5;
    },

    drawCardFromDeck(state) {
      let new_cards_amount = state.progress.cards_amount - 1;

      state.progress.cards_amount = new_cards_amount;
    },
    drawAllCardFromDeck(state) {
      state.progress.cards_amount = 0;
    },
  },

  actions: {
    getProgress({ commit }) {
      return window.api.minigameCollection
        .getProgress(ACTIVITY_KEY)
        .run()
        .then((response) => {
          if (!response.data.error && response.data.result) {
            commit(`setProgress`, response.data.result);
          }
          return response;
        });
    },

    joinActivity({ commit }) {
      return window.api.minigameCollection
        .joinActivity(ACTIVITY_KEY)
        .run()
        .then((response) => {
          if (!response.data.error && response.data.result) {
            commit(`setJoinStatus`, response.data.result);
          }
        });
    },

    drawCard({ commit }) {
      return window.api.minigameCollection
        .drawCard(ACTIVITY_KEY)
        .run()
        .then((response) => {
          if (!response.data.error && response.data.result) {
            commit("drawCardFromDeck");
            commit("setNewCard", response.data.result);
            return response.data.result;
          } else {
            throw new Error(response.data.error.code);
          }
        });
    },

    drawCardAll({ commit }) {
      return window.api.minigameCollection
        .drawCardAll(ACTIVITY_KEY)
        .run()
        .then((response) => {
          if (!response.data.error && response.data.result) {
            commit("drawAllCardFromDeck");
            commit("setNewCardAll", response.data.result);
          } else {
            throw new Error(response.data.error.code);
          }
        });
    },

    upgradeCards({ state }) {
      return window.api.minigameCollection
        .upgradeCards(ACTIVITY_KEY, state.current_row)
        .run()
        .then((response) => {
          if (!response.data.error && response.data.result) {
            return response.data.result;
          } else {
            throw new Error(response.data.error.code);
          }
        });
    },

    claimReward({ state }) {
      return window.api.minigameCollection
        .claimReward(ACTIVITY_KEY, state.current_row)
        .run()
        .then((response) => {
          if (!response.data.error && response.data.result) {
            return response.data.result;
          } else {
            throw new Error(response.data.error.code);
          }
        });
    },

    getImageIds({ commit }, rows) {
      let offers = [];

      rows.forEach((prize) => {
        offers.push(prize.reward_names[0]);
      });

      return window.api.storeService
        .getOffersWithContentsMeta({ offerNames: offers })
        .run()
        .then((response) => {
          if (!response.data.error && response.data.result) {
            let list = [];

            offers.forEach((offer) => {
              response.data.result.forEach((result) => {
                if (result.offer.name === offer) {
                  list.push(result);
                }
              });
            });

            commit("setPrizes", list);
          }
        });
    },
  },
};
